<template>
  <div class="my-3">
    <label>System Message</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 border p-3">
        <label>{{ parseInt(PointsPerUser).toLocaleString() }} points have been added for your selected users</label>
      </div>
    </div>
    <a-table :columns="UserFields" :data-source="SelectedUsers" :pagination="pagination" bordered :row-key="(record) => record.id">
      <span slot="points" slot-scope="text, record">
        <span v-if="record.points < 0" class="badge badge-danger">{{
          record.points
            ? parseInt(record.points)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,')
            : '0.00'
        }}</span>
        <span v-else-if="record.points >= 0" class="badge badge-success">{{
          record.points
            ? parseInt(record.points)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,')
            : '0.00'
        }}</span>
      </span>
      <span slot="updated_points" slot-scope="text, record">
        <span v-if="record.points + PointsPerUser < 0" class="badge badge-danger">{{
          (+record.points + +PointsPerUser).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }}</span>
        <span v-else-if="record.points + PointsPerUser >= 0" class="badge badge-success">{{
          (+record.points + +PointsPerUser).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }}</span>
      </span>
    </a-table>
    <a class="my-3 float-right" href="/point-programs/list">Return To Points Program</a>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AddPointsSystemMessage',
  data() {
    return {
      pagination: {
        showTotal: (total, range) => (
          <div>
            <div>
              {range[0]}-{range[1]} of {total} items
            </div>
          </div>
        ),
        itemRender: (current, type, originalElement) => {
          const totalPages = Math.ceil(this.pagination.total / this.pagination.pageSize);
          if (type === 'next') {
            return (
              <div class="next-buttons">
                <li class="pagination-item">
                  <button type="button" class="btn btn-primary" disabled={totalPages === this.pagination.current}>
                    <font-awesome-icon icon="angle-right" class="m-0" />
                  </button>
                </li>
              </div>
            );
          }
          return originalElement;
        },
        hideOnSinglePage: true,
        total: this.$store.state.adminAddPoint.SelectedUsers.length,
        pageSize: this.$store.state.adminAddPoint.SelectedUsers.length,
      },
      sortBy: 'id',
      sortDesc: false,
      UserFields: [
        {
          title: 'Username',
          key: 'userName',
          dataIndex: 'userName',
          sorter: (a, b) => a.userName.localeCompare(b.userName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'First Name',
          key: 'firstName',
          dataIndex: 'firstName',
          sorter: (a, b) => a.userName.localeCompare(b.firstName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'Last Name',
          key: 'lastName',
          dataIndex: 'lastName',
          sorter: (a, b) => a.userName.localeCompare(b.lastName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'Client Name',
          key: 'name',
          dataIndex: 'clientName',
          sorter: (a, b) => a.clientName.localeCompare(b.clientName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'Points',
          key: 'points',
          dataIndex: 'points',
          scopedSlots: { customRender: 'points' },
          sorter: (a, b) => a.points - b.points,
          sortDirections: ['descend', 'ascend'],
          align: 'right',
        },
        {
          title: 'Updated Points',
          key: 'updated_points',
          scopedSlots: { customRender: 'updated_points' },
          sorter: (a, b) => a.points - b.points,
          sortDirections: ['descend', 'ascend'],
          align: 'right',
        },
      ],
      PointsPerUser: Number(this.$route.params.pointsAdded),
    };
  },
  computed: {
    ...mapState({
      SelectedUsers: (state) => state.adminAddPoint.SelectedUsers,
    }),
  },
  watch: {
    '$store.state.adminAddPoint.SelectedUsers': function() {
      this.pagination = {
        ...this.pagination,
        total: this.$store.state.adminAddPoint.SelectedUsers.length,
        pageSize: this.$store.state.adminAddPoint.SelectedUsers.length,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
